/**
 * These are the constants that recupresents question state.
 * Each value should be equal to the value of the REAL api response!
 * WAITING_TO_OPEN -- this is a temp status for user asking a question without token.
 *
 *  +------------------ REJECT
 *  |                     |
 *  |                     |
 * OPEN --(MATCHING)--- PICKUP ---- ON_GOING ---- UNRATE ---- FINISH
 *  |
 *  |
 * CANCELLED
 *
 */
export const WAITING_TO_OPEN = 'waiting_to_open';
export const OPEN = 'open';
export const PICKED = 'picked';
export const ON_GOING = 'on_going';
export const UNRATE = 'unrate';
export const FINISHED = 'finished';
export const CANCELLED = 'cancelled';
export const MATCHING = 'matching';



// WEBPACK FOOTER //
// ./src/constants/questions.js